import Text from 'components/Text';
import styled from 'styled-components';
import IcAddress from './IcAddress';
import IcPhone from './IcPhone';
import shopSelectors from 'services/shop/selectors';
import { formatPhone } from 'utils/formatPhone';

const BusinessInfoPopoverContent = () => {
  const shopInfo = shopSelectors.data.shopInfo();
  const addressPlus = `${shopInfo?.city ? `${shopInfo?.city}` : ''}${shopInfo?.state ? `, ${shopInfo?.state}` : ''}${shopInfo?.zip ? ` ${shopInfo?.zip}` : ''}`;

  return (
    <Container>
      <div className='header-container'>
        <Text variant='H5' textTransform='uppercase' color='v2_green_8'>
          {shopInfo?.shopName}
        </Text>
      </div>
      <div className='body-container'>
        <div className='body-container-wrapper'>
          <div className='body-container-wrapper-item'>
            <div className='body-container-wrapper-item-icon'>
              <IcAddress />
            </div>
            <div>
              <Text variant='CONTENT_2'>{shopInfo?.address || ''}</Text>
              <Text variant='CONTENT_2'>{addressPlus}</Text>
            </div>
          </div>
          <div className='body-container-wrapper-item'>
            <div className='body-container-wrapper-item-icon'>
              <IcPhone />
            </div>
            <Text variant='CONTENT_2'>{shopInfo?.phone ? formatPhone(shopInfo?.phone) : ''}</Text>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BusinessInfoPopoverContent;

const Container = styled.div`
  display: flex;
  width: 250px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: var(--Neutral-02, #f6f7fc);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);

  .header-container {
    display: flex;
    padding: 16px 8px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
  .body-container {
    display: flex;
    padding: 0px 24px 24px 24px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
  }
  .body-container-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
  }
  .body-container-wrapper-item {
    display: flex;
    align-items: flex-start;
    gap: 4px;
  }
  .body-container-wrapper-item-icon {
    display: flex;
    width: 16px;
    height: 24px;
    justify-content: center;
    align-items: flex-start;
    padding-top: 2px;
    gap: 10px;
  }
`;
